// extracted by mini-css-extract-plugin
export default {"warning":"inline-warning-message_warning__p6mYF"};